import styled from 'styled-components';

export const DownloadWrapper = styled.div``;
